module.exports = __webpack_public_path__ + "static/media/pathogenic_main.f6db95c6.png";